<template>
  <div class="max-w-[100px]">
    <div class="w-[100px] h-[100px] rounded-xl overflow-hidden">
      <img
        src="/landing/images/qr-code-production.png"
        alt="QR for mobile"
        class="w-full h-full object-contain"
      />
    </div>
    <p class="text-center text-white text-xs mt-2 uppercase">
      {{ $t("landing.download.scan_to_download") }}
    </p>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
